import i18n from "i18next";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

let missing = [];
let missingLogTimeout;

let activeMissingKeyHandler = false;
export let setActiveMissignKeyHandler = active => (activeMissingKeyHandler = active);

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        // resources,

        lng: "en",
        fallbackLng: "en",
        load: "all",
        debug: false,

        react: {
            useSuspense: false,
        },

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        parseMissingKeyHandler: key => {
            if (!activeMissingKeyHandler) {
                return;
            }

            !missing.includes(key) && missing.push(key);
            missingLogTimeout && clearTimeout(missingLogTimeout);
            missingLogTimeout = setTimeout(() => {
                console.warn(`Missing translation(s):\n"${missing.join(`"\n"`)}"`);
                missing = [];
            }, 1000);

            return `🚧 ${key}`;
        },
    });

export default i18n;
